export default __webpack_public_path__ + "static/media/lazy_wait.c409b08c.svg";